exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".styles_pageDivider__MsBlZ{background-color:hsla(0,0%,60%,.08);padding:.5rem 1.125rem;margin-right:1rem;font-size:1.0625rem}", ""]);

// exports
exports.locals = {
	"pageDivider": "styles_pageDivider__MsBlZ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/PageDivider/styles.less
// module id = 1935
// module chunks = 8